import { render, staticRenderFns } from "./repayReportForAmount.vue?vue&type=template&id=35c0e2bb&scoped=true&"
import script from "./repayReportForAmount.vue?vue&type=script&lang=js&"
export * from "./repayReportForAmount.vue?vue&type=script&lang=js&"
import style0 from "./repayReportForAmount.vue?vue&type=style&index=0&id=35c0e2bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c0e2bb",
  null
  
)

export default component.exports